<template>
  <a-modal :title="$t('investorList.tzrmx')" :width="1000" :visible="visible" :footer="null" @cancel="handleCancel">
    <div class="borrower-detail-container">
      <div class="search-form">
        <a-form layout="inline">
          <a-form-item>
            <a-input-group compact>
              <a-select v-model="queryParam.searchType" style="width: 130px">
                <a-select-option value="investorName">{{ $t('investorList.tzrmc') }}</a-select-option>
                <a-select-option value="investorId">{{ $t('investorList.tzrID') }}</a-select-option>
                <a-select-option value="investorMobile">{{ $t('investorList.tzrsjh') }}</a-select-option>
              </a-select>
              <a-input v-model="queryParam.searchValue" style="width: 180px" :placeholder="$t('enter')" />
            </a-input-group>
          </a-form-item>
          <a-form-item>
            <a-button type="primary" @click="handleSearch">{{ $t('search') }}</a-button>
          </a-form-item>
        </a-form>
      </div>

      <a-table
        bordered
        :columns="columns"
        :data-source="dataSource"
        :pagination="pagination"
        :loading="loading"
        @change="handleTableChange"
        :rowKey="(record, index) => (record.id ? `${record.id}-${index}` : index)"
      >
        <span slot="investorType" slot-scope="text">
          {{ typeFilter(text) }}
        </span>
        <span slot="mobile" slot-scope="text">
          {{ text | maskPhone }}
        </span>
        <span slot="investAmount" slot-scope="text">
          {{ text | FenToDong }}
        </span>
        <span slot="investRatio" slot-scope="text"> {{ text }}% </span>
        <span slot="investDuration" slot-scope="text">
          {{ text }}
        </span>
        <span slot="investYieldRate" slot-scope="text"> {{ text }}% </span>
        <span slot="investLoanStatus" slot-scope="text">
          {{ loanStatusFilter(text) }}
        </span>
      </a-table>
    </div>
  </a-modal>
</template>

<script>
import { getInvestorList1 } from '@/webpublicapi/vietnamBackstage'

export default {
  name: 'InvestorDetailsModal',
  data() {
    return {
      visible: false,
      loading: false,
      investId: undefined,
      investYieldRate: undefined,
      investAllAmount: undefined,
      queryParam: {
        searchType: 'investorName',
        searchValue: '',
      },
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showTotal: (total) => `${this.$t('components.total')} ${total} ${this.$t('components.items')}`,
      },
    }
  },
  computed: {
    columns() {
      return [
        { title: this.$t('investorList.tzrmc'), dataIndex: 'name', width: 180 },
        {
          title: this.$t('investorList.tzrsjh'),
          dataIndex: 'mobile',
          scopedSlots: { customRender: 'mobile' },
          width: 180,
        },
        {
          title: this.$t('investorList.tzrlx'),
          dataIndex: 'type',
          scopedSlots: { customRender: 'investorType' },
          width: 120,
        },
        {
          title: this.$t('investorList.tzje'),
          dataIndex: 'orderAmount',
          scopedSlots: { customRender: 'investAmount' },
          width: 140,
        },
        {
          title: this.$t('investorList.tzzb'),
          dataIndex: 'investRatio',
          scopedSlots: { customRender: 'investRatio' },
          width: 120,
        },
        {
          title: this.$t('investorList.nhll'),
          dataIndex: 'investYieldRate',
          scopedSlots: { customRender: 'investYieldRate' },
          width: 140,
        },
      ]
    },
  },
  methods: {
    // Phone number masking
    maskPhone(phone) {
      if (!phone) return ''
      const phoneStr = String(phone)
      if (phoneStr.length <= 7) return phoneStr
      return phoneStr.substring(0, 3) + '****' + phoneStr.substring(phoneStr.length - 4)
    },
    show(payload) {
      this.visible = true
      // Compatible with old call method: pass directly investId
      if (payload && typeof payload === 'object') {
        this.investId = payload.investId
        this.investYieldRate = payload.investYieldRate
        this.investAllAmount = payload.investAllAmount
      } else {
        this.investId = payload
        this.investYieldRate = undefined
        this.investAllAmount = undefined
      }
      this.pagination.current = 1
      this.queryParam.searchValue = ''
      this.loadData()
    },
    handleCancel() {
      this.visible = false
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    typeFilter(type) {
      const map = {
        1: this.$t('investorList.gr'),
        10: this.$t('investorList.qy'),
      }
      return map[type] || type || '-'
    },
    loanStatusFilter(status) {
      const map = {
        '-1': this.$t('investorList.lb'),
        0: this.$t('investorList.ddk'),
        1: this.$t('investorList.tzz'),
        2: this.$t('investorList.hkz'),
        3: this.$t('investorList.ywc'),
      }
      return map[status] || status
    },
    loadData() {
      if (!this.investId) {
        this.dataSource = []
        this.pagination.total = 0
        return
      }

      this.loading = true
      const params = {
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        investId: this.investId,
      }

      const keyword = (this.queryParam.searchValue || '').trim()
      if (keyword) {
        // Backend by field name name / id / mobile Query
        params[this.queryParam.searchType] = keyword
      }

      getInvestorList1(params)
        .then((res) => {
          if (res.success && res.respData) {
            const { records, total, current } = res.respData
            const list = records || []
            // Add annualized rate and investment ratio for each record (total amount from asset package)
            this.dataSource = list.map((item) => {
              const amount = Number(item.orderAmount)
              const totalAmount = Number(this.investAllAmount)
              let ratio = 0
              if (Number.isFinite(amount) && Number.isFinite(totalAmount) && totalAmount > 0) {
                ratio = (amount / totalAmount) * 100
              }
              return {
                ...item,
                investYieldRate: this.investYieldRate,
                investRatio: Number.isFinite(ratio) ? ratio.toFixed(2) : 0,
              }
            })
            this.pagination.total = total || 0
            this.pagination.current = current || 1
          } else {
            this.dataSource = []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="less" scoped>
.borrower-detail-container {
  padding: 10px 20px;

  .search-form {
    margin-bottom: 16px;
  }
}
</style>
